// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"31748762","675":"31748762"}[chunkId] + ".chunk.css";
};